export default {
    'sidebar.consultainventario': 'Consulta inventario',
    'sidebar.historicoinventario': 'Histórico inventario',
    'inventario.titulo': 'Inventario',
    'inventario.producto': 'Producto',
    'inventario.ubicacion': 'Ubicación',
    'inventario.fecha': 'Fecha',
    'inventario.codigoBarrasProducto': 'Código de Barras',
    'inventario.productoDescripcion': 'Producto descripción',
    'inventario.productoSerial': 'Serial producto',
    'inventario.productoLote': 'Lote producto',
    'inventario.familiaIdProducto': 'Familia producto',
    'inventario.clasificacionIdProducto': 'Clasificación producto',
    'inventario.BloqueadoProducto': 'Producto bloqueado',
    'inventario.BodegaCodigo': 'Código bodega',
    'inventario.BodegaId': 'Bodega',
    'inventario.DivisionId': 'División',
    'inventario.FechaInicialMovimiento': 'Fecha inicial',
    'inventario.FechaFinalMovimiento': 'Fecha final',
    'inventario.tablaBodega': 'Bodega',
    'inventario.tablaDivision': 'División',
    'inventario.tablaProducto': 'Producto',
    'inventario.tablaPesoFraccion': 'Peso Recibido',
    'inventario.tablaTipoMovimiento': 'Tipo Movimiento',
    'inventario.tablaDocumento': 'Documento',
    'inventario.tablaCantidad': 'Cantidad',
    'inventario.tablaCantidadTotal': 'Cantidad Total',
    'inventario.tablaSerial': 'Serial',
    'inventario.tablaLote': 'Lote',
    'inventario.tablaFechaVencimiento': 'Fecha De Vencimiento',
    'inventario.tablaFechaMovimiento':'Fecha de Movimiento',
    'inventario.tablaFechaIngreso': 'Fecha de Ingreso',
    'inventario.tablaValor': 'Costo',
    'inventario.tablaPeso': 'Peso',
    'inventario.tablaEstado': 'Estado',
    'inventario.tablaCodigoEmpresa': 'Código producto ',
    'inventario.CodigoProducto':'Código producto',
    'inventario.ProductoBloqueado': 'Producto Bloqueado',
    'inventario.DocumentoAsociado': 'Documento Asociado',
    'inventario.Si': 'Si',
    'inventario.No': 'No',
    'inventario.errorDescargarExcel' :'El número de registros en la consulta de inventario supera el límite de exportación. Para habilitar la opción de exportación a Excel, aplique filtros y reduzca la cantidad de datos a menos de 5000 registros.',
    'inventario.filtroObligatorio': 'Debe seleccionar al menos un filtro para realizar la búsqueda.',
};
